import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format } from 'date-fns';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNutrient(value: number): string {
  return value.toFixed(1);
}

export function formatCalories(value: number): string {
  return Math.round(value).toString();
}

export function formatDate(date: Date | number): string {
  return format(date, 'dd/MM/yyyy');
}